import Cookies from 'js-cookie'
import { BFF_STATUS, PARAM_CSRF_TOKEN } from '../../constants'
import store from '../../store'

function injectTimeDriftInfo(response) {
  try {
    const bffTS = new Date(response.headers.date).getTime()
    const timedrift = Date.now() - bffTS

    if (Math.abs(timedrift) > 10 * 60 * 1000) {
      // 10 minutes
      response.data.timedrift = timedrift
    }
  } catch (error) {
    // Just ignore the error: it might be caused by a missing date header, ...
  }
}

function injectHeaders(req) {
  req.headers['X-Date'] = new Date().toUTCString()
  const cookiesCSRF = Cookies.get(PARAM_CSRF_TOKEN)
  if (cookiesCSRF) {
    req.headers[PARAM_CSRF_TOKEN] = cookiesCSRF
  } else {
    const stateCSRF = store.getState().session[PARAM_CSRF_TOKEN]
    if (stateCSRF) {
      req.headers[PARAM_CSRF_TOKEN] = stateCSRF
    }
  }
  return req
}

/**
 * Handles errors from axios responses
 * ref: https://github.com/axios/axios?tab=readme-ov-file#handling-errors
 * @param {Object} error - The error object from axios
 * @returns {Promise} - A rejected promise with the error data
 */
function errorHandler(error) {
  /**
   * The request was made and the server responded with a status code
   * that falls out of the range of 2xx
   *
   * The error is expected to be in the format:
   * {
   *  error: 'error_code',
   *  errorDescription: 'A human readable description of the error',
   *  'x-request-id': 'An unique id for the request'
   * }
   */
  if (error.response) {
    injectTimeDriftInfo(error.response)

    const errorData = error.response.data

    // Returning entire error to check the 'retry_after' on headers
    const isRetryError =
      errorData.error === BFF_STATUS.TOO_MANY_REQUESTS || errorData.error === BFF_STATUS.NOT_YET_VERIFIED

    if (isRetryError) {
      return Promise.reject(error)
    }

    const isBlobError =
      errorData.error === BFF_STATUS.CAPTCHA_REQUIRED &&
      errorData.errorDescription === BFF_STATUS.ARKOSE_ERROR_DESCRIPTION

    if (isBlobError) {
      return Promise.reject({
        errorDescription: errorData.errorDescription,
        'x-request-id': errorData['x-request-id']
      })
    }

    return Promise.reject(errorData)
  } else {

  /**
   * The request was made but no response was received
   * `error.request` is an instance of XMLHttpRequest in the browser and an instance of
   * http.ClientRequest in node.js
   *
   * or
   *
   * Something happened in setting up the request that triggered an Error
   */
    if (error.code === 'ECONNABORTED') {
      // No 'x-request-id' available in this case
      return Promise.reject({
        error: BFF_STATUS.REQUEST_TIMEOUT,
        errorDescription: 'The request took too long to complete. Please try again.'
      })
    }

    return store.dispatch.error.goError()
  }
}

async function requestInterceptor(req) {
  injectHeaders(req)
  return req
}

async function responseInterceptor(res) {
  return res
}

export { injectHeaders, errorHandler, requestInterceptor, responseInterceptor }
